(() => {
  const initMobileCoreSlider = (root) => {
    if (!root || root.dataset.coreMobileDragReady === 'true') return;

    const slider = root.querySelector('[data-core-mobile-slider]');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('[data-core-mobile-slide]'));
    if (!slides.length) return;

    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let suppressClick = false;

    root.dataset.coreMobileDragReady = 'true';

    const getPaddingLeft = () => parseFloat(getComputedStyle(slider).paddingLeft) || 0;

    const getSlideTargetLeft = (slide) => Math.max(0, slide.offsetLeft - getPaddingLeft());

    const snapToNearest = () => {
      const current = slider.scrollLeft;
      let nearest = slides[0];
      let nearestDistance = Infinity;

      slides.forEach((slide) => {
        const distance = Math.abs(getSlideTargetLeft(slide) - current);
        if (distance < nearestDistance) {
          nearest = slide;
          nearestDistance = distance;
        }
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slider.scrollTo({
        left: getSlideTargetLeft(nearest),
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    };

    const endDrag = (event) => {
      if (pointerId === null) return;
      if (event && event.pointerId !== undefined && event.pointerId !== pointerId) return;

      try {
        if (slider.hasPointerCapture(pointerId)) slider.releasePointerCapture(pointerId);
      } catch (error) {}

      slider.classList.remove('is-dragging');
      pointerId = null;

      if (moved) {
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 80);
        snapToNearest();
      }
    };

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      moved = false;
      slider.classList.add('is-dragging');

      try {
        slider.setPointerCapture(pointerId);
      } catch (error) {}
    });

    slider.addEventListener('pointermove', (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;

      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) > 4) moved = true;
      if (!moved) return;

      slider.scrollLeft = startScrollLeft - deltaX;
    });

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('lostpointercapture', endDrag);

    slider.addEventListener('dragstart', (event) => event.preventDefault());
    slider.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-core-scroll-product]').forEach(initMobileCoreSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
